<template>
	<div>
	<h2>Inquilino # {{this.id}}</h2>
	<br>
	<a @click="$router.go(-1)">regresar</a>
	<br><br>

	<div id='captura'>
		<div name='inquilino-ver' v-if='inquilinoSolo !=null'>
			<table name='todos1' align="center" v-for= "inquilinos in inquilinoSolo">
				<tr>
				<td>id:</td>
				<td>{{inquilinos.id}}</td>
				</tr>
				<tr>
				<td>nombreCompleto:</td>
				<td>{{inquilinos.nombreCompleto}}</td>
				</tr>
				<tr>
				<td>email:</td>
				<td>{{inquilinos.email}}</td>
				</tr>
				<tr>
				<td>celular:</td>
				<td>{{inquilinos.celular}}</td>
				</tr>
				<tr>
				<td>telefonoFijo:</td>
				<td>{{inquilinos.telefonoFijo}}</td>
				</tr>
				<tr>
				<td>whatsapp:</td>
				<td>{{inquilinos.whatsapp}}</td>
				</tr>
				<tr>
				<td>facebook:</td>
				<td>{{inquilinos.facebook}}</td>
				</tr>
				<tr>
				<td>dirCalle:</td>
				<td>{{inquilinos.dirCalle}}</td>
				</tr>
				<tr>
				<td>dirNumero:</td>
				<td>{{inquilinos.dirNumero}}</td>
				</tr>
				<tr>
				<td>dirInterior:</td>
				<td>{{inquilinos.dirInterior}}</td>
				</tr>
				<tr>
				<td>dirColonia:</td>
				<td>{{inquilinos.dirColonia}}</td>
				</tr>
				<tr>
				<td>dirCodigo:</td>
				<td>{{inquilinos.dirCodigo}}</td>
				</tr>
				<tr>
				<td>dirCiudad:</td>
				<td>{{inquilinos.dirCiudad}}</td>
				</tr>
				<tr>
				<td>dirEstado:</td>
				<td>{{inquilinos.dirEstado}}</td>
				</tr>
				<tr>
				<td>status:</td>
				<td>{{inquilinos.status}}</td>
				</tr>
				<tr>
				<td>fechaModifica:</td>
				<td>{{inquilinos.fechaModifica}}</td>
				</tr>
				<tr>
				<td>quienModifico:</td>
				<td>{{inquilinos.quienModifico}}</td>
				</tr>
			</table>
		</div>
		<span v-else>Cargando inquilino</span>
	</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default{
		name:'inquilino-ver',
	
		mounted(){
			this.entrar();
		},
		props:['vector'],
		data(){
			return{
				id: null,
				inquilinoSolo: null	
			}
		},
		methods:{
			entrar(){
				// checa si tiene autorizacion
		  		if(!this.vector.includes('MASTERGGUV')){
			  		if(!this.vector.includes('Inquilinos Ver detalle')){
			  			document.getElementById('captura').hidden = true;
			  			alert('Seccion no autorizada');
			  			return;
			  		}
			  	}
				this.id=this.$route.params.id;
				axios.get('https://www.directodo.com/Rentus/accesosdb/leeUnInquilino.php?id='+this.id)
	  		         .then((respue) => {
	  		     		this.inquilinoSolo=respue.data;
	  			 	 });
			}
		}
	}
</script>

<style lang="scss">
	table #todos1 {
	    font-family: arial, sans-serif;
	    border-collapse: collapse;
	    width: 100%;
	}

	tr, th {
	    border: 1px solid #dddddd;
	    text-align: left;
	    padding: 8px;
	}

	tr:nth-child(even) {
	    background-color: #dddddd;
	}

</style>


// WEBPACK FOOTER //
// src/Inquilino-ver.vue